export class LoginRequest {
    idToken: string;

    constructor(idToken: string) {
        this.idToken = idToken;
    }
}